import { useFormik } from "formik";
import { adminUpdateEvent } from "helpers/backend_helpers";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { toast } from "react-toastify";
import {
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import Flatpickr from "react-flatpickr";
import * as Yup from "yup";
import moment from "moment";

const EditModalEvent = ({ show, onCloseClick, getData, data }: any) => {
  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: data?.name || "",
      location: data?.location || "",
      eventDatetime: data?.eventDatetime || "",
      note: data?.note || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Nama harus diisi!"),
      location: Yup.string().required("Lokasi harus diisi!"),
      eventDatetime: Yup.string().required("Tanggal dan jam harus diisi!"),
      note: Yup.string(),
    }),
    onSubmit: (values) => {
      const formattedValues = {
        ...values,
        eventDatetime: moment(values.eventDatetime).format(
          "YYYY-MM-DDTHH:mm:ss",
        ),
      };

      adminUpdateEvent(data._id, formattedValues)
        .then((response: any) => {
          onCloseClick();
          getData();
          toast.success(
            <div>
              Event <b>{response?.name}</b> berhasil diupdate!
            </div>,
          );
          validation.resetForm();
        })
        .catch(() => {});
    },
  });

  useEffect(() => {
    if (!show) {
      validation.resetForm();
    }
  }, [show]);

  return (
    <Modal fade={true} isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalHeader className="bg-light p-3" toggle={onCloseClick}>
        Edit Event
      </ModalHeader>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}
      >
        <ModalBody>
          <div className="mb-3">
            <Label htmlFor="name" className="form-label">
              Nama
            </Label>
            <Input
              type="text"
              className="form-control"
              id="name"
              name="name"
              placeholder="Nama Event"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.name || ""}
              invalid={
                validation.touched.name && validation.errors.name ? true : false
              }
            />
            {validation.errors.name && validation.touched.name ? (
              <FormFeedback type="invalid">
                {validation.errors.name}
              </FormFeedback>
            ) : null}
          </div>

          <div className="mb-3">
            <Label htmlFor="location" className="form-label">
              Lokasi
            </Label>
            <Input
              type="text"
              className="form-control"
              id="location"
              name="location"
              placeholder="Lokasi"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.location || ""}
              invalid={
                validation.touched.location && validation.errors.location
                  ? true
                  : false
              }
            />
            {validation.errors.location && validation.touched.location ? (
              <FormFeedback type="invalid">
                {validation.errors.location}
              </FormFeedback>
            ) : null}
          </div>

          <div className="mb-3">
            <Label htmlFor="eventDatetime" className="form-label">
              Tanggal dan Jam
            </Label>
            <Flatpickr
              className="form-control"
              options={{
                enableTime: true,
                dateFormat: "Y-m-d H:i",
                time_24hr: true,
              }}
              placeholder="Tanggal dan Jam"
              value={validation.values.eventDatetime || ""}
              onChange={(date) => {
                validation.setFieldValue("eventDatetime", date[0]);
              }}
              onClose={() => {
                validation.setFieldTouched("eventDatetime", true);
              }}
            />
            {validation.errors.eventDatetime &&
            validation.touched.eventDatetime ? (
              <FormFeedback type="invalid" className="d-block">
                {validation.errors.eventDatetime}
              </FormFeedback>
            ) : null}
          </div>

          <div className="mb-3">
            <Label htmlFor="note" className="form-label">
              Catatan
            </Label>
            <Input
              type="textarea"
              className="form-control"
              id="note"
              rows={4}
              placeholder="Catatan"
              name="note"
              value={validation.values.note || ""}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-soft-danger waves-effect waves-light material-shadow-none btn-sm"
            data-bs-dismiss="modal"
            onClick={onCloseClick}
          >
            Batal
          </button>
          <button
            type="submit"
            className="btn btn-soft-success waves-effect waves-light material-shadow-none btn-sm"
          >
            Simpan
          </button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

EditModalEvent.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  getData: PropTypes.func,
  data: PropTypes.object,
};

export default EditModalEvent;
